import styled from 'styled-components'

export const Badge = styled.span`
  text-align: center;
  display: inline-block;
  font-family: Roboto, sans-serif;
  border-radius: ${(props) => props.totalSizeInRem / 2}rem;
  background-color: ${(props) =>
    props.score > 0 ? props.theme.accent2 : props.theme.accent1};
  color: white;
  height: ${(props) => props.heightInRem}rem;
  min-width: ${(props) => props.totalSizeInRem}rem;
  padding: ${(props) => props.paddingInRem}rem;
  font-size: ${(props) => props.fontSizeInRem}rem;
  line-height: ${(props) => props.fontSizeInRem}rem;
`

export const CardBadgePositioning = styled.div`
  position: absolute;
  top: -${(props) => props.totalSizeInRem / 2}rem;
  right: -${(props) => props.totalSizeInRem / 2}rem;
  line-height: 0;
`

export const CardScoringBadge = ({
  fontSizeInRem = 0.8,
  paddingInRem = 0.2,
  heightInRem = 1.2,
  score,
}) => {
  const totalSizeInRem = fontSizeInRem + paddingInRem * 2

  return (
    <CardBadgePositioning
      {...{ fontSizeInRem, paddingInRem, totalSizeInRem, heightInRem, score }}
    >
      <ScoringBadge
        {...{ fontSizeInRem, paddingInRem, totalSizeInRem, heightInRem, score }}
      />
    </CardBadgePositioning>
  )
}

export const ScoringBadge = ({
  score,
  fontSizeInRem = 0.8,
  paddingInRem = 0.2,
  heightInRem = 1.2,
  totalSizeInRem = paddingInRem + heightInRem,
}) => {
  const plusOrMinus = score > 0 ? '+' : ''
  const displayScore = `${plusOrMinus}${score}`
  return (
    <Badge
      {...{ score, fontSizeInRem, paddingInRem, heightInRem, totalSizeInRem }}
    >
      {displayScore}
    </Badge>
  )
}
